import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api-client';
import type { AppSummary } from '../types/api';

export const appsKeys = {
  all: ['apps'] as const,
  list: () => [...appsKeys.all, 'list'] as const,
};

export function useAppsList() {
  return useQuery({
    queryKey: appsKeys.list(),
    queryFn: async () => (await api.get<{ apps: AppSummary[] }>('/apps')).apps,
  });
}
